import { createNetworkStatusNotifier } from 'react-apollo-network-status';

const networkStatusNotifier = createNetworkStatusNotifier();

export const networkStatusLink = networkStatusNotifier.link;
export const useApolloNetworkStatus =
  networkStatusNotifier.useApolloNetworkStatus;
